<div class="one-subnav-breadcrumbs">
  @if (!isMobile) {
    <ol class="one-subnav-breadcrumbs-list">
      @for (crumb of breadcrumbs; track crumb; let last = $last) {
        <li class="one-subnav-breadcrumbs-list__crumb">
          @if (last) {
            <span class="one-subnav-breadcrumbs-list__crumb-last" [innerText]="crumb.label | translate: crumb.translationParams"></span>
          }
          @if (!last) {
            <a
              class="one-subnav-breadcrumbs-list__crumb-link"
              [routerLink]="crumb.url"
              [innerText]="crumb.label | translate: crumb.translationParams"
            >
            </a>
          }
          @if (!last) {
            <span class="one-subnav-breadcrumbs-list__crumb-separator">/</span>
          }
        </li>
      }
    </ol>
  } @else {
    @if (currentCrumb) {
      <div class="one-subnav-breadcrumbs-mobile">
        @if (hasPrevious) {
          <qp-icon [name]="iconNames.IC_ARROW_LEFT" (click)="goToPrevious()" class="one-subnav-breadcrumbs-mobile__icon"></qp-icon>
        }
        <span class="one-subnav-breadcrumbs-mobile__label">{{ currentCrumb.label | translate: currentCrumb.translationParams }}</span>
      </div>
    }
  }
</div>
